module.exports = __webpack_public_path__ + "static/media/life-at-xenonstack.51c62ca6.webp";